import React from "react";
import NotesHistory from "./notesHistory";
import { usePrecandidateContext } from "../context/Context";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { useTranslation } from "react-i18next";

const PreCandidateHistory = () => {
  const {
    modalHistoryShow,
    setModalHistoryShow,
    precandidateSelected
  } = usePrecandidateContext();
  const { t } = useTranslation();

  return (
    <ModalContainer
      modalTitle={t("History")}
      modalSubtitle={precandidateSelected}
      isOpen={modalHistoryShow}
      closeModal={() => setModalHistoryShow(false)}
      crossmarkAction={() => setModalHistoryShow(false)}
    >
      <NotesHistory />
    </ModalContainer>
  );
};

export default PreCandidateHistory;
